import { firstPage } from '../../../State/pagination'
import fetch from '../../../Services/fetch'

export default () => (dispatch) => {

  dispatch(firstPage())
  
  dispatch(fetch())

}
